import React from 'react'

export const NotificationTitle = ({ title }: { title: string }) => {
  return <h2 className="mb-2 font-semibold whitespace-pre-line">{title}</h2>
}
